{
  "es": {
    "sublines": {
      "impressum": {
        "general": "General Information (according to § 5 TMG)",
        "disclaimer": "Descargo de responsabilidad",
        "copyright": "Derechos de autor",
        "thirdpartycontent": "Créditos",
        "sponsors": "Patrocinadores",
        "liabilityInternal": "Limitation of liability for internal content",
        "liabilityExternal": "Limitation of liability for external links"
      }
    }
  }
}
